import { useId } from 'react';
import styles from './Checkbox.module.css';

interface CheckboxProps {
  inputId?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  hint?: string;
  disabled?: boolean;
}

const Checkbox = ({
  inputId,
  checked,
  onChange,
  label,
  hint,
  disabled = false
}: CheckboxProps) => {
  const generatedId = useId();
  const id = inputId ?? `cb-${generatedId}`;
  const hintId = hint ? `${id}-hint` : undefined;

  return (
    // add disabled class to container when appropriate
    <div className={`${styles.container} ${disabled ? styles.disabled : ''}`}>
      <div className={styles.row}>
        <input
          id={id}
          type="checkbox"
          className={styles.input}
          checked={checked}
          disabled={disabled}
          onChange={(e) => onChange(e.target.checked)}
          aria-describedby={hintId}
        />

        <label htmlFor={id} className={styles.label}>
          <div className={styles.box} aria-hidden="true">
            <svg
              className={styles.checkmark}
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.6666 3.5L5.24992 9.91667L2.33325 7"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>

          {label && <span className={styles.labelText}>{label}</span>}
        </label>
      </div>

      {hint && (
        <small id={hintId} className={styles.hint}>
          {hint}
        </small>
      )}
    </div>
  );
};

export default Checkbox;
